import { createSlice } from '@reduxjs/toolkit';

const skillGroupSlice = createSlice({
  name: 'skillGroup',
  initialState: {
    skillGroups: [],
    dataValid: false,
    skillGroupMembers: [],
    skillGroup: {}
  },
  reducers: {
    setSkillGroups(state, action) {
        if (!action || !action.payload || !action.payload.skillGroups) {
          state.skillGroups = [];
        } else {
          state.skillGroups = action.payload.skillGroups.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()) );
        }      
    },
    setSkillGroup(state, action) {
        if (!action || !action.payload || !action.payload.skillGroup) return;
        if(!state.skillGroup){
            state.skillGroup = action.payload.skillGroup;
        } else {
            state.skillGroup = {...state.skillGroup, ...action.payload.skillGroup}
        }
    },
    setSkillGroupDivisions(state, action) {
        if (!action || !action.payload || !action.payload.skillGroupDivisions) return;
        if( !state.skillGroup ) {
            state.skillGroup = {divisions: action.payload.skillGroupDivisions};
        } else {
            state.skillGroup.divisions = action.payload.skillGroupDivisions;
        }
    },
    setSkillGroupMembers(state, action) {
        console.count("skillGroupSlice: setSkillGroupMembers");
        if (!action || !action.payload || !action.payload.skillGroupMembers) {
          state.skillGroupMembers = [];
        } else {
          state.skillGroupMembers = action.payload.skillGroupMembers;
          state.dataValid = !!action.payload.dataValid;
        }
    },
    clearSkillGroup(state, action){
      state.skillGroupMembers = [];
      state.dataValid = true;
      state.skillGroup = {};
    },
    invalidateData(state, action) {
        state.dataValid = false;
    },
  },
});

export const skillGroupActions = skillGroupSlice.actions;

export default skillGroupSlice;